/**
 * Persists where the customer should return after Auðkenni / storefront login
 * (e.g. cart or checkout intent). Consumed by assets/verify.js (hidden return_to + redirects).
 */
(function () {
  'use strict';

  function cartUrl() {
    if (typeof window !== 'undefined' && window.routes && window.routes.cart_url) {
      return window.routes.cart_url;
    }
    return '/cart';
  }

  function checkoutUrl() {
    var root =
      typeof window !== 'undefined' &&
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    if (root.indexOf('/') !== 0) root = '/' + root;
    if (root.length > 1 && root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'checkout';
  }

  function safeStore(value) {
    try {
      if (!value || typeof value !== 'string') return;
      if (value.indexOf('//') !== -1) return;
      if (value.charAt(0) !== '/') return;
      if (value.length > 2048) return;
      sessionStorage.setItem('audkenni_return_to', value);
    } catch (e) {}
  }

  var path = window.location.pathname || '';
  var search = window.location.search || '';
  var cu = cartUrl();
  var norm = function (p) {
    return (p || '').replace(/\/$/, '') || '/';
  };
  if (norm(path) === norm(cu)) {
    safeStore(checkoutUrl());
  }

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      var href = (a.getAttribute('href') || '').toLowerCase();
      var isLogin =
        href.indexOf('/account/login') !== -1 ||
        href.indexOf('/account/register') !== -1 ||
        href.indexOf('innskraning') !== -1;
      if (!isLogin) return;
      var onCart =
        norm(path) === norm(cu) ||
        (a.closest && a.closest('cart-drawer'));
      if (onCart) {
        safeStore(checkoutUrl());
      }
    },
    true
  );

  try {
    var stored = sessionStorage.getItem('audkenni_return_to');
    if (
      stored &&
      (stored.indexOf('/checkout') === 0 ||
        norm(stored.split('?')[0]) === norm(cu))
    ) {
      window.__AUDKENNI_CHECKOUT_INTENT__ = true;
    }
  } catch (e) {}
})();
